<template>
    <div>
        <!-- Modale per la selezione dell'articolo -->
        <div class="modal-backdrop fade show" v-if="show"></div>
        <div class="modal fade" :class="{ 'show': show, 'd-block': show }" id="switchArticleModal" tabindex="-1"
            aria-labelledby="switchArticleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="switchArticleModalLabel">Seleziona un articolo</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            @click="$emit('close')"></button>
                    </div>
                    <div class="modal-body">
                        <div class="switch-to-article">
                            <!-- Campo di ricerca -->
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="search-article-addon">
                                    <!-- Icona Bootstrap 5 -->
                                    <i class="bi bi-search"></i>
                                </span>
                                <input type="text" class="form-control" placeholder="Cerca articolo per titolo..."
                                    aria-label="Cerca articolo" aria-describedby="search-article-addon"
                                    v-model="searchQuery" @input="filterContentTree" ref="searchInput">
                            </div>


                            <!-- Risultati della ricerca -->
                            <div v-if="searchQuery.length > 0" class="search-results">
                                <div v-if="filteredArticles.length === 0" class="text-center py-3">
                                    <em>Nessun articolo trovato</em>
                                </div>
                                <div v-else class="list-group-b article-tree">
                                    <div class="mb-3">
                                        <h6 class="ms-2 mb-2 section-title">Risultati della ricerca</h6>
                                        <button v-for="article in filteredArticles" :key="article.id"
                                            class="list-group-item list-group-item-action"
                                            :style="{ paddingLeft: '16px' }"
                                            @click="navigateToArticle(article.id, article.versionId)">
                                            <span class="article-prefix">└─</span>
                                            {{ article.title }}
                                            <small class="text-muted ms-2">({{ article.sectionTitle }})</small>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Lista strutturata degli articoli -->
                            <div v-else>
                                <div v-if="allArticles.length === 0" class="text-center py-3">
                                    <em>Caricamento articoli...</em>
                                </div>
                                <div v-else class="list-group article-tree">
                                    <div v-for="section in groupedArticles" :key="section.id" class="mb-3">
                                        <h6 class="ms-2 mb-2 section-title"
                                            :style="{ paddingLeft: (section.level * 16) + 'px' }">
                                            <span v-if="section.level > 0" class="section-prefix">└─</span>
                                            {{ section.title }}
                                        </h6>
                                        <button v-for="article in section.articles" :key="article.id"
                                            class="list-group-item list-group-item-action"
                                            :style="{ paddingLeft: ((section.level + 1) * 16) + 'px' }"
                                            @click="navigateToArticle(article.id, article.versionId)">
                                            <span class="article-prefix">└─</span>
                                            {{ article.title }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" @click="$emit('close')">Chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ContainerNode from '../navigator/ContainerNode.vue';
import { cloneDeep } from 'lodash';

export default {
    name: 'SwitchToArticle',
    components: {
    },
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            searchQuery: '',
            contentTreeRef: null,
            filteredArticles: [],
            allArticles: [],
            groupedArticles: [],
            modalInstance: null
        }
    },
    created() {
        // Ritardiamo l'operazione di 2 secondi per assicurarci che l'albero dei contenuti sia completamente caricato
        setTimeout(async () => {
            // Verifica se l'albero dei contenuti è disponibile
            if (!this.$root.contentTree) {
                try {
                    // Attendi il caricamento dell'albero dei contenuti
                    await this.$root.fetchContents();
                } catch (error) {
                    console.error('SwitchToArticle: Error fetching content tree:', error);
                }
            }

            // Verifica nuovamente se l'albero dei contenuti è disponibile
            if (this.$root.contentTree) {
                this.contentTreeRef = cloneDeep(this.$root.contentTree);
                this.loadAllArticles();
            }
        }, 2000);
    },
    methods: {
        /**
         * Carica tutti gli articoli dall'albero dei contenuti
         */
        loadAllArticles() {
            const articles = [];
            const structuredSections = [];

            // Funzione ricorsiva per costruire la struttura dell'albero
            const processContentTree = (nodes, parentPath = '', level = 0) => {
                // Processiamo ogni nodo mantenendo l'ordine originale
                nodes.forEach(node => {
                    if (node.type === 'section') {
                        // Costruisci il percorso della sezione
                        const currentPath = parentPath ? `${parentPath} > ${node.activeTitle}` : node.activeTitle;

                        // Crea l'oggetto sezione
                        const sectionObj = {
                            id: node.id,
                            title: node.activeTitle,
                            path: currentPath,
                            level: level, // Aggiungi il livello di profondità
                            articles: []
                        };

                        // Aggiungi gli articoli che sono figli diretti di questa sezione
                        if (node.childrens && node.childrens.length > 0) {
                            node.childrens.forEach(child => {
                                if (child.type === 'content') {
                                    // Processa l'articolo
                                    if (child.versions && child.versions.length > 0) {
                                        const currentVersion = child.findCurrentVersion ? child.findCurrentVersion() : child.versions[0];

                                        if (currentVersion) {
                                            const title = currentVersion.title || child.title || '';

                                            const articleInfo = {
                                                id: child.id,
                                                versionId: currentVersion.id,
                                                title: title,
                                                sectionTitle: currentPath,
                                                level: level // Aggiungi il livello di profondità anche per gli articoli
                                            };

                                            // Aggiungi l'articolo sia all'elenco completo che alla sezione
                                            articles.push(articleInfo);
                                            sectionObj.articles.push(articleInfo);
                                        }
                                    }
                                }
                            });
                        }

                        // Aggiungi la sezione anche se non ha articoli
                        structuredSections.push(sectionObj);

                        // Processa ricorsivamente le sottosezioni
                        if (node.childrens && node.childrens.length > 0) {
                            const childSections = node.childrens.filter(child => child.type === 'section');
                            if (childSections.length > 0) {
                                processContentTree(childSections, currentPath, level + 1);
                            }
                        }
                    }
                });
            };

            // Inizia il processo dall'albero dei contenuti
            if (this.$root.contentTree && this.$root.contentTree.nodes) {
                processContentTree(this.$root.contentTree.nodes);
            }

            this.allArticles = articles;
            this.groupedArticles = structuredSections;
        },



        /**
         * Filtra l'albero dei contenuti in base alla query di ricerca
         */
        filterContentTree() {
            if (this.searchQuery.length === 0) {
                this.filteredArticles = [];
                return;
            }

            const query = this.searchQuery.toLowerCase();
            const resultsMap = new Map(); // Usa una Map per evitare duplicazioni basate sull'ID dell'articolo

            // Funzione ricorsiva per cercare articoli nell'albero
            const searchInNode = (node, sectionPath = '', level = 0) => {
                // Se il nodo è una sezione
                if (node.type === 'section') {
                    const currentPath = sectionPath ? `${sectionPath} > ${node.activeTitle}` : node.activeTitle;

                    // Cerca nei figli della sezione
                    if (node.childrens && node.childrens.length > 0) {
                        // Cerca prima nei figli di tipo articolo
                        node.childrens.filter(child => child.type === 'content').forEach(child => {
                            searchInNode(child, currentPath, level + 1);
                        });

                        // Poi cerca nelle sottosezioni
                        node.childrens.filter(child => child.type === 'section').forEach(child => {
                            searchInNode(child, currentPath, level + 1);
                        });
                    }
                }
                // Se il nodo è un articolo
                else if (node.type === 'content') {
                    // Cerca nelle versioni dell'articolo
                    if (node.versions && node.versions.length > 0) {
                        const currentVersion = node.findCurrentVersion ? node.findCurrentVersion() : node.versions[0];

                        if (currentVersion) {
                            const title = currentVersion.title || node.title || '';

                            // Se il titolo contiene la query di ricerca
                            if (title.toLowerCase().includes(query) || sectionPath.toLowerCase().includes(query)) {
                                // Usa l'ID dell'articolo come chiave per evitare duplicazioni
                                if (!resultsMap.has(node.id)) {
                                    resultsMap.set(node.id, {
                                        id: node.id,
                                        versionId: currentVersion.id,
                                        title: title,
                                        sectionTitle: sectionPath,
                                        level: 0 // Tutti i risultati di ricerca hanno level 0 per l'indentazione
                                    });
                                }
                            }
                        }
                    }
                }
            };

            // Inizia la ricerca dal nodo radice
            if (this.$root.contentTree && this.$root.contentTree.nodes && this.$root.contentTree.nodes.length > 0) {
                this.$root.contentTree.nodes.forEach(node => searchInNode(node));
            }

            // Converti la Map in array e limita i risultati a 15 per evitare di sovraccaricare l'interfaccia
            this.filteredArticles = Array.from(resultsMap.values()).slice(0, 15);
        },

        /**
         * Naviga all'articolo selezionato e chiude la modale
         */
        navigateToArticle(articleId, versionId) {
            this.$router.push({ path: '/index.html', query: { article: articleId, version: versionId } });
            this.$emit('article-selected', { articleId, versionId });
            //this.$emit('close');
        }
    }
}
</script>

<style scoped>
.section-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #0066cc;
    transition: padding-left 0.2s ease;
}

.section-prefix {
    margin-right: 5px;
    color: #5c6f82;
}

.article-prefix {
    margin-right: 5px;
    color: #5c6f82;
}

.list-group-item {
    transition: padding-left 0.2s ease;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.article-tree {
    max-height: 60vh;
    overflow-y: auto;
}

.modal-body {
    padding: 1.5rem;
}

.switch-to-article {
    width: 100%;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.5;
}



::v-deep(.list-group-item.active),
::v-deep(.list-group-item:hover),
::v-deep(.list-group-item:focus),
::v-deep(.list-group-item:active),
::v-deep(.list-group-item:focus-visible) {
    border: 1px solid black !important;
    /* BORDO SELEZIONE */
    background-color: #ffffff !important;
    /* BIANCO SEMPRE */
    color: #0066cc !important;
    /* TESTO COSTANTE */

    box-shadow: none !important;
    /* niente ombre gialline */
    outline: none !important;
}

::v-deep(.list-group-item) {
    transition: padding-left 0.2s ease;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    color: #0066cc !important;
    background-color: #ffffff !important;
    /* BIANCO */

    border: 1px black !important;
    /* BORDO SOTTILE */

    box-shadow: none !important;
    outline: none !important;
    cursor: pointer;
}
</style>